import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'

/**
 * The app's one cache client.
 *
 * The defaults are deliberately conservative (`CACHE_AUDIT.md` §5.2, `R-08`):
 * `staleTime: 0` and `retry: false`, because this client serves money and stock
 * reads — a 30 s default staleness (`R-08`) or a retried 403 (`C-14`) is a
 * correctness bug, not a performance trade. A query opts into caching by
 * passing `staleTime` from the per-class presets in `useRpcQuery.ts`; a query
 * that opts into nothing is simply refetched, which is the safe failure.
 *
 * `refetchOnWindowFocus` is off; the live read-only views that want it (`L3`)
 * ask for it explicitly.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

export function installQuery(app: { use: (plugin: unknown, options: unknown) => void }): void {
  app.use(VueQueryPlugin, { queryClient })
}